"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useLabsApiAuth } from "@/lib/labsIdentityContext";

/**
 * When the signed-in user's account is disabled, restrict them to the homepage.
 * Any attempt to view another route redirects back to "/", where the header lets
 * them reactivate their account.
 */
export default function DisabledRouteGuard() {
  const { profile, loading } = useLabsApiAuth();
  const pathname = usePathname() ?? "";
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (profile?.isDisabled && pathname !== "/") {
      router.replace("/");
    }
  }, [loading, profile?.isDisabled, pathname, router]);

  return null;
}
